import { render } from "./AppointmentModal.vue?vue&type=template&id=13dca620&scoped=true"
import script from "./AppointmentModal.vue?vue&type=script&lang=js"
export * from "./AppointmentModal.vue?vue&type=script&lang=js"

import "./AppointmentModal.vue?vue&type=style&index=0&id=13dca620&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13dca620"]])

export default __exports__